import { comum } from "../../../../styles/Themes/light";
import { IconClose } from "../../../icons";
import ModalDefault from "../../../ModalDefault";
import { ModalContactHead, ModalcontactMain } from "../../../SearchProfessionalProposal/styles";

export default function ModalContato({modalAtivo, setModalAtivo, children}: {modalAtivo: any, setModalAtivo: any, children: React.ReactNode}) {
    return (

            <ModalDefault
                id={'overlayModal'}
                onClose={() => setModalAtivo((modalAtivo: any) => !modalAtivo)}
                openModal={modalAtivo}
                width="fit-content"
            >
                <ModalContactHead>
                    <div>
                        Entre em contato
                    </div>

                    <div
                        className="close"
                        onClick={() => setModalAtivo(false)}
                    >
                        <IconClose color={comum.colors.primaryRed400} />
                    </div>
                </ModalContactHead>
                
                <ModalcontactMain>
                    {children}
                </ModalcontactMain>
            </ModalDefault> 
    )
}